import { useEffect } from 'react';
import { pushEvent } from '../utils/gtm';
import { getAttribution } from '../utils/attribution';
import { GA4_EVENTS, FORM_STEP_NAMES } from '../constants/ga4Events';

/** Fires form_step_view GA4 event whenever `step` changes. */
export function useFormStepView(step: number) {
  useEffect(() => {
    pushEvent(GA4_EVENTS.FORM_STEP_VIEW, {
      form_step: step,
      form_step_name: FORM_STEP_NAMES[step] ?? String(step),
      ...getAttribution(),
    });
  }, [step]);
}
